<template>
  <div>
    邮箱: {{ userContent.email ? userContent.email : "-" }} <br />
    电话: {{ userContent.phone ? userContent.phone : "-" }}<br />
    姓名: {{ userContent.realName ? userContent.realName : "-" }}<br />
    地址: {{ userContent.address ? userContent.address : "-" }}<br />
  </div>
</template>

<script>
import { content } from "@/service/user";
export default {
  name: "UserContent",
  components: {},
  data() {
    return {
      userContent: {},
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      content({
        userId: this.$route.params.id,
      }).then((res) => {
        const { code, data } = res;
        if (code == 0) {
          this.userContent = data;
        }
      });
    },
  },
};
</script>
